import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { AppContext } from '/@/app/AppContext';
import { ChatbotView } from '/@/app/views/ChatbotView';

export function TestLayout()
{

const mainViewportRef = React.useRef(null);
const appContext = useContext(AppContext);
appContext.mainViewportRef = mainViewportRef;

return (
<Box sx={{ display: 'flex', height:'100dvh', flexDirection:'column' }}>
<IconButton component={RouterLink} to="/cabinet" sx={{ position: 'fixed', top: 16, right: 16, zIndex: 2000, bgcolor: 'background.paper', boxShadow: 2, '&:hover': { bgcolor: 'background.paper', }, }} > <ArrowBackIcon /> </IconButton>
<Box ref={mainViewportRef} sx={{ flexGrow: 1, height: '100%', overflowY: 'auto', overflowX: 'hidden', }}>
<ChatbotView/>
</Box>
</Box>
);
}

